import React from 'react';

/**
 * Sticky top banner shown while a Manager Override is armed in the
 * picking / pressing / packing portal. Renders remaining-seconds
 * countdown from `expiresAt` (ms epoch) and the current `now` (also ms).
 *
 * Parent portal owns the 1s tick that drives `now`; this component just
 * reads and renders, so mounting/unmounting is cheap.
 *
 * Padding on top respects `env(safe-area-inset-top)` so the banner clears
 * an iPhone notch / dynamic island when the portal runs full-screen.
 */
export default function ManagerOverrideBanner({ expiresAt, now }) {
    if (!expiresAt || !now) return null;
    const remaining = Math.max(0, Math.ceil((expiresAt - now) / 1000));
    return (
        <div
            style={{
                background:  '#1d4ed8',
                color:       '#ffffff',
                fontWeight:  700,
                fontSize:    13,
                letterSpacing: '0.03em',
                padding:     'calc(8px + env(safe-area-inset-top, 0px)) 14px 8px',
                textAlign:   'center',
                position:    'sticky',
                top:         0,
                zIndex:      200,
                borderBottom: '1px solid #1e40af',
            }}
        >
            ⚡ MANAGER OVERRIDE ACTIVE — scan-only bypassed for this order ({remaining}s)
        </div>
    );
}
